var _clipPath, _clipPath2, _clipPath3, _clipPath4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    viewBox: "0 0 223.33571 62.030003",
    width: 223.33571,
    height: 62.030003,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 612 V 792 H 0 Z",
    id: "path18"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,581.76 h 207 v 94.07 H 0 Z",
    id: "path44"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 204,675.83 H 407.999 V 581.76 H 204 Z",
    id: "path56"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 408,581.76 h 204 v 94.07 H 408 Z",
    id: "path68"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath208"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 38.4,766.02453 H 217.6 V 816 H 38.4 Z",
    id: "path210",
    style: {
      strokeWidth: 1.06666672
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    },
    id: "g10",
    transform: "matrix(1.25,0,0,-1.25,-177.84082,869.11312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g204",
    transform: "translate(103.34155,-120.7095)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g206",
    clipPath: "url(#clipPath208)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g212",
    transform: "translate(100.73504,782.88021)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -13.6224,-6.8533333 c -7.8944,-3.2991997 -10.96,-3.5210667 -18.5888,0.7477333 -8.0832,4.5226667 -18.4,5.58506667 -28.626133,-6.554667 -0.4608,-0.546133 -1.0976,-1.216 -0.942934,-1.851733 -0.016,-0.02667 0.02027,0.0224 0,0 -0.554666,-0.731733 8.951467,14.53973333 27.488,1.0368 4.5696,-3.3312 9.152,-3.380267 18.714667,2.3264 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path214"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    transform: "translate(51.17344,815.5216)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 9.4261333,-21.909333 V 0 H 15.709867 V -35.297067 H 8.4896 L -2.7008,-9.7376 V -35.297067 H -8.9856 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path218"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g220",
    transform: "translate(86.619733,796.92693)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.05546667,1.488 0.16533333,6.064 -3.5285333,6.064 -3.4176,0 -3.472,-4.1344 -3.5274667,-6.064 z m -7.1114667,-4.3552 c -0.0544,-3.6928 -0.1098666,-7.661867 3.6384,-7.661867 3.2522667,0 3.63840003,2.9216003 3.85920003,4.6848003 L 7.1658667,-7.7728 C 6.6154667,-10.308267 5.1264,-17.253333 -3.6384,-17.253333 c -8.3232,0 -11.300267,6.558933 -11.300267,13.7802663 0,1.7642667 0.2208,6.064 2.039467,9.3717334 1.9296,3.4730666 5.5125333,5.1808003 9.2064,5.1808003 4.7402667,0 7.6618667,-2.6453337 8.8746667,-4.961067 1.9296,-3.6928 1.984,-7.1658667 1.984,-10.4736 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g224",
    transform: "translate(105.63883,791.30421)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-3.9146667 0,-6.2293333 3.1968,-6.2293333 3.0869333,0 3.3632,3.3632 3.3632,9.0954666 C 6.56,7.6618667 6.3392,11.4656 3.4176,11.4656 0,11.4656 0,7.6074667 0,5.1818667 Z m -0.4416,16.096 v -4.078933 c 0.9376,1.764266 2.4266667,4.465066 6.1194667,4.465066 1.8186666,0 3.8581333,-0.772266 5.1818663,-2.094933 C 13.506133,11.6864 14.3872,7.4421333 14.3872,2.8661333 14.3872,-0.992 13.835733,-11.4656 5.1818667,-11.4656 2.2048,-11.4656 0.82666667,-9.9776 0,-9.0954667 V -20.285867 H -7.4421333 V 16.096 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path226"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g228",
    transform: "translate(132.98123,816)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V -8.5994667 H 5.0165333 V -14.552533 H 0 v -9.9776 c 0,-5.127467 0,-5.7888 5.4026667,-5.458134 V -35.776 c -1.1029334,-0.219733 -2.6464,-0.551467 -4.6858667,-0.551467 -2.4810667,0 -5.2373333,0.606934 -6.7797333,2.811734 -1.3237334,1.9296 -1.3237334,4.685866 -1.3237334,8.157866 v 10.805334 h -2.9770663 v 5.9530663 h 3.3631997 L -6.3936,-0.60586667 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path230"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g232",
    transform: "translate(149.46411,807.40043)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -17.474133 c 0,-2.7008 0,-4.4096 2.5909333,-4.4096 3.3632,0 3.3632,2.149333 3.3632,7.992533 V 0 H 13.506133 V -27.176533 H 6.3946667 v 3.748266 C 5.0165333,-25.742933 3.8037333,-27.728 -0.60586667,-27.728 -7.552,-27.728 -7.552,-22.656 -7.552,-17.694933 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path234"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g236",
    transform: "translate(176.64139,807.40043)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -3.6928 c 1.1029333,2.2602667 2.5354667,4.29866667 6.7797333,4.29866667 1.0485334,0 4.1343997,0 6.0095997,-2.86613337 1.101867,-1.7088 1.101867,-4.3552 1.101867,-7.056 V -27.176533 h -7.552 v 17.8602663 c 0,2.4256 -0.2208,4.0245334 -2.5909333,4.0245334 -3.36213337,0 -3.36213337,-2.6464 -3.36213337,-5.9541337 V -27.176533 H -7.1658667 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g240",
    transform: "translate(210.43381,796.92693)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.05546667,1.488 0.16533333,6.064 -3.5285333,6.064 -3.4176,0 -3.472,-4.1344 -3.5274667,-6.064 z m -7.1114667,-4.3552 c -0.055467,-3.6928 -0.1098666,-7.661867 3.6384,-7.661867 3.2522667,0 3.63840003,2.9216003 3.85920003,4.6848003 L 7.1658667,-7.7728 C 6.6144,-10.308267 5.1264,-17.253333 -3.6384,-17.253333 c -8.324267,0 -11.300267,6.558933 -11.300267,13.7802663 0,1.7642667 0.2208,6.064 2.039467,9.3717334 1.9296,3.4730666 5.5125333,5.1808003 9.2053333,5.1808003 4.7413334,0 7.6629334,-2.6453337 8.8757334,-4.961067 1.9296,-3.6928 1.984,-7.1658667 1.984,-10.4736 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g244",
    transform: "translate(123.80416,776.70549)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 7.3397333 V -1.5157333 H 4.5472 V -10.021333 H 2.7786667 v 8.5055997 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g248",
    transform: "translate(134.27573,766.68437)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 10.021333 H 6.4565333 V 8.5610667 h -4.688 V 5.9648 H 5.7962667 V 4.5056 H 1.7685333 V 1.4602667 H 6.5546667 V 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path250"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g252",
    transform: "translate(146.27691,772.36885)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 1.9232 c 1.2490667,0 1.8805333,0.53333333 1.8805333,1.3610667 0,0.9130666 -0.6602666,1.4037333 -1.5584,1.4037333 H 0 Z M -1.7685333,-5.6842667 V 4.336 h 4.4352 c 1.7408,0 2.9898666,-0.7573333 2.9898666,-2.6944 0,-1.48693333 -0.8426666,-2.09066667 -2.0917333,-2.3296 V -0.7168 C 4.9258667,-0.7722667 5.4730667,-1.5018667 5.4730667,-2.7925333 V -4.3232 c 0,-0.5749333 0.1685333,-0.9685333 0.5621333,-1.3610667 H 3.8730667 C 3.5786667,-5.264 3.6213333,-4.7018667 3.6213333,-4.3648 v 1.2906667 c 0.013867,1.4453333 -0.1258666,1.5584 -1.7408,1.5584 H 0 v -4.1685334 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path254"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g256",
    transform: "translate(164.79093,774.60011)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -0.02773333 L -2.9194667,-7.9157333 h -1.4592 L -7.2426667,0 H -7.2704 V -7.9157333 H -9.0389333 V 2.1056 h 2.7232 L -3.6490667,-5.2490667 -0.92586667,2.1056 H 1.7685333 V -7.9157333 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path258"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 170.77227,776.70613 h 1.76853 V 766.6848 h -1.76853 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path260"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g262",
    transform: "translate(183.72747,776.70549)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 1.7685333 V -10.021333 H -0.04266667 L -5.1936,-2.7925333 H -5.221333 V -10.021333 H -6.9898667 V 0 h 1.8528 l 5.10933337,-7.2981333 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path264"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g266",
    transform: "translate(191.06912,770.40363)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 2.9333333 l -1.4176,4.0842667 H 1.488 Z M 0.6176,6.3018667 H 2.4138667 L 6.2741333,-3.7194667 H 4.3082667 l -0.8277334,2.2592 h -4.04159997 l -0.87040003,-2.2592 h -1.9658666 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path268"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g270",
    transform: "translate(201.40011,768.144)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 4.7445333 V -1.4602667 H -1.7685333 V 8.5610667 H 0 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path272"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g274",
    transform: "translate(209.96288,769.96853)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.4314667 1.0666667,-2.0490667 2.3434667,-2.0768 0.9408,0.027733 2.2037333,0.4064 2.2037333,1.55733333 0,2.45653337 -6.1194667,0.53333334 -6.1194667,4.50559997 0,2.1610667 1.88053337,3.0602667 3.8176,3.0602667 1.9381334,0 3.888,-0.8 4.0426667,-3.4389333 H 4.4352 c 0,1.4176 -0.9536,1.9221333 -2.1194667,1.9221333 -1.41759997,0 -2.03519997,-0.6176 -2.03519997,-1.3610667 0,-2.2176 6.12053337,-0.3786666 6.12053337,-4.4629333 0,-2.2314667 -1.8816,-3.2981333 -4.1557334,-3.2981333 -2.34346663,0 -4.0554666,1.0666666 -4.0981333,3.5925333 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.06666672
    },
    id: "path276"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc6130420d7e4e2ad1fc31fb69cbf07a.svg";
export { ForwardRef as ReactComponent };